module.exports = __webpack_public_path__ + "img/uke-chord.7156a778.jpg";